import {Component, Input} from '@angular/core';

@Component({
  selector: 'iv-live-input-tooltip',
  templateUrl: './input-tooltip.component.html',
  styleUrls: ['./input-tooltip.component.css']
})
export class InputTooltipComponent {

  @Input() position: 'top' | 'right';

  showTooltip = false;
  message: string;
  inputPositionStyles: { top: string; right: string } = {
    'right': 'input-tooltip-right',
    'top': 'input-tooltip-top'
  };
  figurePositionStyles: { top: string; right: string } = {
    'right': 'input-tooltip-figure-right',
    'top': 'input-tooltip-figure-top'
  };
  show(message: string) {
    this.message = message;
    this.showTooltip = true;
  }

  hide() {
    this.showTooltip = false;
  }
}
